<div class="bodyHeight">
  
    <div *ngIf="showMsg">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10  col-lg-offset-5 col-lg-6 col-xl-5">
            <!-- <div class="img-out">
              <img src="assets/Logo.jpg" class="mx-auto d-block" alt="awlm-logo">
            </div> -->
            <div class="forBoarder">
              <div class="login-lable">
                <a routerLink="/login" [queryParams]="{redirectTo:''}"><i class="back-to-login-icon fa fa-2x fa-angle-left" aria-hidden="true"></i></a><a class="back-to-login"
                  routerLink="/login" [queryParams]="{redirectTo:''}">Back to Login</a>
                 
                <div class="text-center forgot-title">FORGOT PASSWORD?</div>
                <p class="text-center desc-title">Please enter your email address below.</p>
              </div>
              <form [formGroup]="forgotPasswordForm">
               
                <div class="form-group form-input">
                  <input type="email" placeholder="Email Address" class="form-control email-input" name="userName"
                    formControlName="userName" required>
                  <div *ngIf="forgotPasswordForm.get('userName').hasError('required')&&forgotPasswordForm.get('userName').touched">
                    <small class="error">Email is required</small>
                  </div>
                  <div *ngIf="forgotPasswordForm.get('userName').hasError('pattern')&&forgotPasswordForm.get('userName').touched">
                    <small class="error">Please enter valid email</small>
                  </div>
                  <div  *ngIf="errorMsg">
                     <small  class="error">{{forgotData?.data}}</small>
                  </div>
                </div>
                <div class="text-center">
                  <button class="RGARRButton" type="submit" (click)="postForgotEmail()">SUBMIT</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
    <div *ngIf="!showMsg">
      <div class="container-fluid ">
        <div class="row justify-content-center">
          <div class=" col-12 col-md-10  col-lg-offset-5 col-lg-6 col-xl-5">
            <!-- <div class="img-out">
              <img src="./assets/resources/img/Ahyush_Logo.png" class="mx-auto d-block" alt="awlm-logo">
            </div> -->
            <div class="panel-wrap">
              <div class="thanks-msg">
                <p> {{forgotData?.data}}</p>
              </div>
              <div class="w-100"></div>
              <div class="text-center">
                <a routerLink='/login' [queryParams]="{redirectTo:''}"><button class="RGARRButton forBTN" type="button">OK</button></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  